const fun = {
    time: (mydate) => {
        var unixtimestamp = new Date(mydate);
        var year = 1900 + unixtimestamp.getYear();
        var month = "0" + (unixtimestamp.getMonth() + 1);
        var date = "0" + unixtimestamp.getDate();
        var hour = "0" + unixtimestamp.getHours();
        var minute = "0" + unixtimestamp.getMinutes();
        var second = "0" + unixtimestamp.getSeconds();
        return year + "-" + month.substring(month.length - 2, month.length) + "-" + date.substring(date.length - 2, date.length)
            + " " + hour.substring(hour.length - 2, hour.length) + ":"
            + minute.substring(minute.length - 2, minute.length) + ":"
            + second.substring(second.length - 2, second.length);

    },
    compareDate: (arr) => {
        //获取当前时间
        let currentTime = new Date();
        //自定义时间
        arr && arr.forEach((item, index) => {
            let startActivityTime = new Date(Date.parse((item.startActivityTime.split('T')[0] + ' ' + item.startActivityTime.split('T')[1]).replace("-", "/")));
            let endActivityTime = new Date(Date.parse((item.endActivityTime.split('T')[0] + ' ' + item.endActivityTime.split('T')[1]).replace("-", "/")));
            let stratRegistrationTime = new Date(Date.parse((item.stratRegistrationTime.split('T')[0] + ' ' + item.stratRegistrationTime.split('T')[1]).replace("-", "/")));
            let endRegistrationTime = new Date(Date.parse((item.endRegistrationTime.split('T')[0] + ' ' + item.endRegistrationTime.split('T')[1]).replace("-", "/")));
                
            if(currentTime>endActivityTime){//当前时间大于结束时间
                console.log('已结束');
                item.type = 2;
            }else if(stratRegistrationTime<currentTime&&currentTime<endRegistrationTime){ //当前时间在报名开始时间和报名结束时间之间
                console.log('报名中');
                item.type = 1;
            }else if(startActivityTime<currentTime&&currentTime<endActivityTime){ //当前时间在活动开始时间和活动结束时间之间
                console.log('进行中');
                item.type = 0;
            }else if (currentTime<stratRegistrationTime) {//当前时间在报名开始之前
                console.log('已发布');
                item.type = 3;
            }
        })
        return arr
    }
}
export default fun